import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";
import { v4 as uuidv4 } from "uuid";

export default createStore({
  state: {
    // 初始化类别数据
    categories: [
      { categoryId: "1", name: "Education" },
      { categoryId: "2", name: "Healthcare" },
      { categoryId: "3", name: "Financial" },
      { categoryId: "4", name: "Electronics" },
      { categoryId: "5", name: "Digital" },
      { categoryId: "6", name: "Goverment" },
      { categoryId: "7", name: "Manufacturing" },
      { categoryId: "8", name: "Energy" },
    ],
    tasks: [], // 添加任务列表状态
    latestTaskTitles: {}, // 添加这个状态
  },
  mutations: {
    // 同步更改状态的方法 // 更新类别数据的 mutation
    updateCategories(state, categories) {
      state.categories = categories;
    },
    addTask(state, task) {
      console.log("Before adding task:", task);
      state.tasks.push(task);
      console.log("After adding task:", state.tasks);
    },
    updateLatestTaskTitle(state, { categoryName, taskTitle }) {
      state.latestTaskTitles[categoryName] = taskTitle;
    },
  },
  actions: {
    addNewTask({ commit }, taskDetails) {
      const newTask = {
        ...taskDetails,
        id: uuidv4(), // 生成唯一ID
        registrationDay: taskDetails.day, // 添加当前日期作为注册日期
      };
      console.log("New task with registrationDay:", newTask);
      commit("addTask", newTask);
    },
    setLatestTaskTitle({ commit }, payload) {
      commit("updateLatestTaskTitle", payload);
    },
  },
  modules: {
    // 分模块的状态管理
  },
  getters: {
    // 获取类别数据的 getter
    categories: (state) => state.categories,
    tasks: (state) => state.tasks, // 获取任务列表的getter
    tasksForToday: (state) => {
      const today = new Date().toISOString().split("T")[0];
      return state.tasks.filter((task) => task.registrationDay === today);
    },
    latestTaskTitles: (state) => state.latestTaskTitles,
  },
  plugins: [
    createPersistedState({
      paths: ["categories", "tasks"], // 指定需要持久化的状态
    }),
  ],
});
